import { logger } from '@/util';
import callBackendApi from './call';

export interface CampaignRecord {
  id: number;
  title: string;
}

export const getCampaigns = async (
  token: string,
  searchValue: string, // Empty if there is no value to search for.
  abortSignal?: AbortSignal
) => {
  logger.debug('getCampaigns() called', { token, searchValue, abortSignal });
  const searchValueEncoded = encodeURIComponent(searchValue);
  const endpoint = `/campaignsofcivicrm/containing/${searchValueEncoded}`;
  const data = await callBackendApi({
    token,
    method: 'get',
    endpoint: endpoint,
    abortSignal,
  });

  return data as CampaignRecord[];
};

export const getCampaignsByIds = async (
  token: string,
  ids: number[],
  abortSignal?: AbortSignal
) => {
  logger.debug('getCampaignsByIds() called', { token, ids, abortSignal });

  const data = await callBackendApi({
    token,
    method: 'get',
    endpoint: `/campaignsofcivicrm?ids=${JSON.stringify(ids)}`,
    abortSignal,
  });
  return data as CampaignRecord[];
};
